import React from 'react';

const CurrentSubscription = () => {
  return (<div>
    <h1>Current Subscription</h1>
  </div>)
}

export default CurrentSubscription